import { createContext } from "react";

export const PrivateKeyContext = createContext("");
